import { Navigate, useParams } from "react-router-dom";

/** The retired line pages (`/desks/:deskId/lines/:jobId`): Team settings, at the Agent that holds the line. */
export function LinePageRedirect() {
  const { deskId, jobId } = useParams<{ deskId: string; jobId: string }>();
  return <Navigate to={`/desks/${encodeURIComponent(deskId ?? "")}?settings=${encodeURIComponent(jobId ?? "team")}`} replace />;
}
